<p>{{data.text}}</p>
<button data-cy="subproject-hierarchy-limit-modal__c-btn" type="button" mat-stroked-button class="pull-right mt-10 c-btn" (click)="dialogRef.close()">{{ 'close' | transloco }}</button>
